import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    width={65.5}
    height={65.5}
    viewBox="0 0 65.5 65.5"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .cls-1 {\n        fill: #f7f7f7;\n      }\n\n      .cls-2 {\n        fill: #e1e1e1;\n      }\n    "
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
    <g id="Vkl7mI.tif">
      <g>
        <path class="cls-1" d="M.4,61.4l10.4-10.4-3.4-3.4,5.4-5.4,1.3,1.2c.9.8,1.9,1.1,2.7.4s1-1.9.2-2.7l-1.6-1.6,1.8-1.8,1.6,1.6c.8.8,2,.6,2.6,0,.9-.9.6-2.1-.2-2.9l-1.4-1.3,1.8-1.8,1.6,1.6c.8.8,2,.7,2.7-.1s.6-1.9-.2-2.6l-1.5-1.5,1.8-1.8,1.6,1.6c.7.7,1.8.6,2.5,0s.9-1.8.2-2.6l-1.7-1.8,8.8-8.8-3.3-3.4c-.6-.7-.5-1.9,0-2.4s1.7-.9,2.5-.1l17.5,17.5c.8.8.6,2-.1,2.7s-1.8.6-2.6-.2l-3.2-3.2-30.1,30.1-3.4-3.4-10.4,10.4L.4,61.4Z"/>
        <path class="cls-2" d="M60.4,12.7l-9.6,9.6-7.2-7.2,9.6-9.6-2.4-2.4c-.7-.7-.6-2,0-2.5s1.8-.7,2.6.1l11.7,11.7c.8.8.9,1.9.2,2.7s-1.8.8-2.6,0l-2.3-2.3Z"/>
      </g>
    </g>
  </g>
  </svg>
);
export default SVGComponent;
